import {
    CONIFER_3,
    FALL_1,
    FALL_3,
    FALL_10,
    SPRING_10,
    SUMMER_3,
    SUMMER_10,
    WINTER_2,
    WINTER_3,
    WINTER_10,
} from '@gaia/colors';
import {alpha, styled} from '@mui/material/styles';

const AlertRoot = styled('div')(({theme}) => ({
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    textAlign: 'center',
}));

const alertStyles = {
    success: {
        backgroundColor: SPRING_10,
        borderColor: alpha(CONIFER_3, 0.2),
        color: CONIFER_3,
    },
    warning: {
        backgroundColor: FALL_10,
        borderColor: alpha(FALL_3, 0.2),
        color: FALL_1,
    },
    error: {
        backgroundColor: SUMMER_10,
        borderColor: alpha(SUMMER_3, 0.2),
        color: SUMMER_3,
    },
    notice: {
        backgroundColor: WINTER_10,
        borderColor: alpha(WINTER_3, 0.2),
        color: WINTER_2,
    },
};

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
    variant: 'success' | 'warning' | 'error' | 'notice';
}

export default function Alert({children, variant, ...props}: AlertProps) {
    return (
        <AlertRoot sx={alertStyles[variant]} {...props}>
            {children}
        </AlertRoot>
    );
}
